import { BlockTitle } from "@blocks/Blocks";

/**
 * Component to render SCA contact us page
 */
const SCAContactUsPage = (): React.ReactElement => {
  return (
    <div
      data-testid="sca-contact-us-page-component"
      className="font-public-sans"
    >
      <BlockTitle
        text="Contact Us"
        rootClassName="my-3 text-4xl md:text-6xl lg:text-8xl font-medium font-poppins"
      />

      <p className="mb-6">
        For nominations or more information on Singapore Corporate Awards,
        please contact:
      </p>

      <ul className="mb-6">
        <li>
          <strong>The Singapore Corporate Awards Secretariat</strong>
        </li>
        <li>
          <strong>c/o Ms Ong Yu Fan</strong>
        </li>
      </ul>

      <ul className="mb-6">
        <li>The Business Times</li>
        <li>1000 Toa Payoh North</li>
        <li>Podium Level 3, Singapore 318994</li>
      </ul>

      <ul className="mb-6">
        <li>Email: yufanong@sph.com.sg</li>
      </ul>
    </div>
  );
};

export default SCAContactUsPage;
